import { useState, useEffect } from "react";
import { Select } from "antd";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { __ } from "../../locales/translation";
import { fetchSearchItems, fetchResumenHistorico } from "../../utils/fetchers";
import { ComparatorChart } from "../ComparatorChart";
import { StatsBig } from "../Stats";
import { createAutoCompleteOptions } from "../../utils/utils";

export default function Comparator() {
    const params = useParams();
    const { productId } = params;

    const [firstOptionToCompare, setFirstOptionToCompare] = useState(productId);
    const [secondOptionToCompare, setSecondOptionToCompare] = useState(null);
    const [thirdOptionToCompare, setThirdOptionToCompare] = useState(null);

    const { isLoading: isLoadingSearchItems, data: searchItems } = useQuery({
        queryKey: ["searchItems"],
        queryFn: fetchSearchItems,
    });

    // Creamos queries para cada ID utilizando React Query
    // La opción 'enabled' permite evitar peticiones innecesarias si el ID no está presente
    const {
        isLoading: firstOptionIsLoading,
        isError: firstOptionIsError,
        data: firstOptionData,
    } = useQuery({
        queryKey: ["resumenHistorico", firstOptionToCompare],
        queryFn: () => fetchResumenHistorico(firstOptionToCompare, "", ""),
    });

    const {
        isLoading: secondOptionIsLoading,
        isError: secondOptionIsError,
        data: secondOptionData,
    } = useQuery({
        queryKey: ["resumenHistorico", secondOptionToCompare],
        queryFn: () => fetchResumenHistorico(secondOptionToCompare, "", ""),
        enabled: !!secondOptionToCompare,
    });

    const {
        isLoading: thirdOptionIsLoading,
        isError: thirdOptionIsError,
        data: thirdOptionData,
    } = useQuery({
        queryKey: ["resumenHistorico", thirdOptionToCompare],
        queryFn: () => fetchResumenHistorico(thirdOptionToCompare, "", ""),
        enabled: !!thirdOptionToCompare,
    });

    // must be the filled with the actual product
    const options = createAutoCompleteOptions(searchItems, params.productType);

    useEffect(() => {
        if (productId) {
            setFirstOptionToCompare(productId);
        }
    }, []);

    if (firstOptionIsError) {
        return <div>{__("Error")}</div>;
    }

    return (
        <div className="cot-product-comparator">
            <div className="comparator-controls">
                <div className="comparator-control">
                    <StatsBig
                        title={firstOptionToCompare || `${__("Selecciona una opción")}`}
                        value={null}
                        currency={null}
                    />

                    <Select
                        disabled={true}
                        loading={firstOptionIsLoading}
                        showSearch
                        value={firstOptionToCompare}
                        onSelect={(value, record) => {
                            setFirstOptionToCompare(() => record.code);
                        }}
                        options={options}
                    />
                </div>

                <div className="comparator-control">
                    <StatsBig
                        title={secondOptionToCompare || `${__("Selecciona una opción")}`}
                        value={null}
                        currency={null}
                    />

                    <Select
                        disabled={isLoadingSearchItems}
                        loading={secondOptionIsLoading}
                        showSearch
                        onSelect={(value, record) => {
                            setSecondOptionToCompare(() => record.code);
                        }}
                        options={options}
                    />
                </div>

                <div className="comparator-control">
                    <StatsBig
                        title={thirdOptionToCompare || `${__("Selecciona una opción")}`}
                        value={null}
                        currency={null}
                    />

                    <Select
                        disabled={isLoadingSearchItems}
                        loading={thirdOptionIsLoading}
                        showSearch
                        onSelect={(value, record) => {
                            setThirdOptionToCompare(() => record.code);
                        }}
                        options={options}
                    />
                </div>
            </div>

            <ComparatorChart
                firstOptionData={firstOptionData}
                secondOptionData={secondOptionData}
                thirdOptionData={thirdOptionData}
            />
        </div>
    );
}
